<template>
  <div :class="$style.container">
    <div>{{ getDateField(data.date) }} / {{ data.caption }}</div>
    <img
      :class="$style.screen"
      :src="url"
    >
  </div>
</template>

<script>
  import { getScreenshotLink } from '@/api/methods/computers';
  import { formatDate, getTime } from '@/helpers/format-date';

  export default {
    name: 'LogScreen',
    props: ['data'],

    computed: {
      url() {
        return getScreenshotLink(this.data.compId, this.data.path);
      },
    },
    methods: {
      getDateField(value) {
        const date = formatDate(value);
        const time = getTime(value);
        return `${date} ${time}`;
      },
    },
  };
</script>

<style lang="scss" module>
  .container {
    padding: 20px;
    height: 100%;
  }
  .screen {
    margin-top: 5px;
    padding-top: 20px;
    width: 100%;
  }
</style>
